<template>
    <div class="chart" style="position: relative;">
        <div style="position: absolute; left:30px ; top: 24px;  z-index: 1; display: flex; justify-content: space-between; align-items: center; width: 600px;">
            <div style="display: flex;width: 300px;justify-content: space-around; align-items: center;">
                <div style=" font-weight: bold; width: 50px;">排行</div>
                <div :class="{fontcolor:index == colorIndex}" class="chart-btn" style="margin-left: 30px; "
                     v-for="(item,index) in chartClickText" :key='index' @click="chartsClick" :data-index="index" :data-id="item.key">
					{{item.name}}
                </div>
            </div>
            <div>
                <Select v-model="leftSelectValue" style="width:80px" @on-change="loadData">
                    <Option v-for="item in chart1List" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </div>
        </div>
        <div style="background-color: #FFFFFF; position: absolute; z-index: 1; left: 710px; top: 0px; width: 880px; height: 80px;  display: flex;justify-content: space-between; align-items: center;">
            <Select v-model="rightTypeValue"  style="width:120px" @on-change="chart2LeftClick">
                <Option v-for="item in chart2ListLeft" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Select v-show="!chart2Show" @on-change="loadData" v-model="rightCategoryValue" style="width:80px">
                <Option v-for="item in chart2ListRight" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <Select v-show="chart2Show" @on-change="loadData"  v-model="rightSelectValue" style="width:80px">
                <Option v-for="item in chart1List" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
        </div>
        <div class="chart-biao">
            <div id="Mimelist"></div>
            <div v-show="!chart2Show" id="Mimelist2"></div>
            <div v-show="chart2Show" class="chart-tabel">
                <div style="position: relative; top: 50px; left: -10px; text-align: center; padding-bottom: 5px; border-bottom: 1px solid #EFF0F1;  ">
                    <Row>
                        <Col span="2">客户</Col>
                        <Col span="2">跟进人</Col>
                        <Col span="2">类型</Col>
                        <Col span="16">跟进记录</Col>
                        <Col span="2">状态</Col>
                    </Row>
                </div>
                <div v-for="(item,index) in datumList " :key='index' @click="toClient" :data-id="item.id"
                     style="left: -10px; position: relative; top: 50px; text-align: center; padding: 5px 0; border-bottom: 1px solid #EFF0F1;  ">
                    <Row type="flex" align="middle" style="font-size: 13px;">
                        <Col span="2"
                             style="height: 100%; display: flex; justify-content: center; align-items: center;">
                            <div>{{item.name}}</div>
                        </Col>
                        <Col span="2">{{item.follow_name}}</Col>
                        <Col span="2">{{item.type_name}}</Col>
                        <Col span="16">
                            <div class="blue-color-font" style="width: 200px; margin: 0 auto; cursor: pointer; z-index: 999">
                                <Poptip width="200" word-wrap trigger="hover" placement="bottom">
                                    <div slot="content">
                                        <div v-for="entrust in item.entrust">{{entrust.ext_info.remark}}{{entrust.created_at}}</div>
                                    </div>
                                    {{item.entrust[0].ext_info.remark}}
                                </Poptip>
                            </div>

                        </Col>
                        <Col span="2">{{item.status_name}}</Col>
                    </Row>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
	import {getMiddleHome} from '@/api/shouye'

	import {mapActions, mapGetters} from "vuex";
    export default {
        name: "Chart",
		computed:{
			...mapGetters(['token']),
		},
        data() {
            return {
                rightSelectValue: '5',
                chart2Show: false,
                //图表2中的资料
                datumList: [],
                // 图表2右下拉内容
                chart2ListRight: [
                    {
                        value: 'month',
                        label: '月'
                    },
                    {
                        value: 'week',
                        label: '周'
                    },
                    {
                        value: 'day',
                        label: '天'
                    },
                ],
                rightCategoryValue: 'month',//图表2右绑定
                //图表2左下拉内容
                chart2ListLeft: [
                    {
                        value: 'tendency',
                        label: '趋势'
                    },
                    {
                        value: 'payClue',
                        label: '待回访客户'
                    },],
                rightTypeValue: 'tendency',//图表2左下拉绑定
                leftSelectValue: '5',//图表1下拉绑定
                //图表一下拉选项
                chart1List: [
					{
						value: '0',
						label: '合计'
					},
					{
						value: '1',
						label: '今日'
					},
					{
						value: '2',
						label: '昨日'
					},

					{
						value: '3',
						label: '本周'
					},
					{
						value: '4',
						label: '上周'
					},
					{
						value: '5',
						label: '本月'
					},
					{
						value: '6',
						label: '上月'
					}
				],
				leftChartType: 'distribute',
                chartClickText: [{key: 'distribute', name: '业绩'}, {key: 'sign', name: '签约'}, {key: 'visit', name: '上门'}],
                colorIndex: '0',
                optionLeft: {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    legend: {
                        data: ['2012年']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        min: 0,
                        axisTick: { //x轴刻度线
                            show: false
                        },
                        axisLine: { //x轴
                            show: false
                        },
                    },
                    yAxis: {
                        type: 'category',
                        data: [],
                        axisTick: { //x轴刻度线
                            show: false
                        },
                        axisLine: { //x轴
                            show: false
                        },
                    },
                    series: [
                        {
                            name: '业绩',
                            type: 'bar',
                            data: [],
                            color: '#0092FF',
                            barWidth: '30',
                            label: {
                                show: true, //开启显示
                                position: 'inside', //在上方显示
                                textStyle: { //数值样式
                                    color: 'white',//字体颜色
                                    fontSize: 10//字体大小
                                },
                            }
                        }
                    ]
                },
                optionRight: {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    legend: {
                        data: ['客户(条)', '上门客户(个)', '业绩(元)'],
                        y: 'bottom',
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: [],
                            axisPointer: {
                                type: 'shadow'
                            },
                            axisTick: { //x轴刻度线
                                show: false
                            },
                            axisLine: { //x轴
                                show: false
                            },
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            min: 0,
                            splitLine: {show: false},
                            axisTick: { //y轴刻度线
                                show: false
                            },
                            axisLine: { //y轴
                                show: false
                            },
                        },
                        {
                            type: 'value',
                            min: 0,
                            splitLine: {show: false},
                            axisTick: { //y轴刻度线
                                show: false
                            },
                            axisLine: { //y轴
                                show: false
                            },
                        }
                    ],
                    series: [
                        {
                            name: '客户(条)',
                            type: 'bar',
                            data: [],
                            color: '#0092FF',
                            barGap: '0',
                        },
                        {
                            name: '上门客户(个)',
                            type: 'bar',
                            data: [],
                            color: '#9567E3'
                        },
                        {
                            name: '业绩(元)',
                            type: 'line',
                            yAxisIndex: 1,
                            data: [],
                            color: '#FF3434'
                        }
                    ],
					myChart: null,
					myChart2: null,
                }
            }
        },
        mounted() {
			//创建echarts对象
			this.myChart = this.$echarts.init(document.getElementById("Mimelist"));
			this.myChart2 = this.$echarts.init(document.getElementById("Mimelist2"));
        	this.loadData();
        },
        methods: {
			...mapActions([
				'handleLogOut',
			]),
			async loadData() {
				let that = this;
				let data = {
				    token: this.token,
                    departmentId: window.localStorage['getTopDataDepartmentId'],
                    userId: window.localStorage['getTopDataUserId']
				}
				data.rightSelectValue = this.rightSelectValue;
				data.rightCategoryValue = this.rightCategoryValue;
				data.rightTypeValue = this.rightTypeValue;
				data.leftSelectValue = this.leftSelectValue;
				data.leftChartType = this.leftChartType;
				let res = await getMiddleHome(that, data);
				that.optionLeft.yAxis['data'] = res.data.leftList.yAxis;
				that.optionLeft.series[0]['data'] = res.data.leftList.series;
				this.myChart.setOption(this.optionLeft);
				if (that.rightTypeValue == 'tendency') {
					that.optionRight.xAxis[0]['data'] = res.data.rightList.xAxis;
					that.optionRight.series[0]['data'] = res.data.rightList.series['clueNums'];
					that.optionRight.series[1]['data'] = res.data.rightList.series['visitNums'];
					that.optionRight.series[2]['data'] = res.data.rightList.series['distribute'];
					let series = that.optionRight.series;
					//创建echarts对象
					this.myChart2.setOption(that.optionRight);
				} else {
                    that.datumList = res.data.rightList;
                }
			},
            chartsClick(e) {
            	let index = e.currentTarget.dataset.index;
                this.colorIndex = index
				let id = e.currentTarget.dataset.id;
                this.leftChartType = id;
                this.optionLeft.series[0].name = this.chartClickText[index]['name'];
                this.loadData()
            },
            chart2LeftClick(e) {
                this.chart2Show = !this.chart2Show
                this.loadData();
            },
            toClient(e) {
			    let id = e.currentTarget.dataset.id;
			    window.open(`#/editClue?id=${id}`);
            }
        }
    }
</script>

<style scoped lang="less">
    .blue-color-font:hover {
        color: #0092FF;
    }

    .chart {
        margin-top: 10px;
    }

    .chart-btn {
        cursor: pointer;
        width: 50px;
    }

    #Mimelist {
        width: 700px;
        height: 430px;
        background-color: #FFFFFF;
        padding-top: 30px;
    }

    #Mimelist2 {
        width: 920px;
        height: 430px;
        background-color: #FFFFFF;
        padding-top: 30px;
    }

    .chart-tabel {
        width: 920px;
        height: 430px;
        background-color: #FFFFFF;
        padding-top: 30px;
        overflow: auto;
    }

    .chart-tabel::-webkit-scrollbar {
        width: 5px;
        height: 4px;
        background-color: #f5f5f5;
    }

    .chart-tabel::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background: #cae1f5;
        webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, .2);
    }

    .chart-tabel::-webkit-scrollbar-track { /*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
        background: #fff;
    }

    .chart-biao {
        display: flex;
        align-items: center;
    }

    .fontcolor {
        color: #0092FF;
    }
</style>
